import { Path } from '~/routes/constants';

import { ProviderTypeNames } from '../constants/user.constants';
import { useFlags } from 'launchdarkly-react-client-sdk';

/** Generates a list of authorized links based on the user mode and alias */
export const getAuthorizedLinks = (
  links: {
    alias?: string;
    allow: string[];
    restrictRole?: string;
    iconName: string;
    id: string;
    label: string;
    path: string;
  }[],
  mode: string,
  roles: string[],
): {
  alias?: string;
  allow: string[];
  restrictRole?: string;
  iconName: string;
  id: string;
  label: string;
  path: string;
}[] => {
  return links.reduce((updatedLinks, def) => {
    const { alias, allow, restrictRole } = def;
    const includesAllowedRoles = !restrictRole || roles.includes(restrictRole);
    if (allow.includes(mode) && includesAllowedRoles) {
      return [
        ...updatedLinks,
        {
          ...def,
          path: alias === Path.CALENDAR ? Path.CALENDAR_SCHEDULE : def.path,
        },
      ];
    }
    return updatedLinks;
  }, []);
};

/** Tests whether two paths are a match by comparing each segment ("/" delimiter ignored) */
export const isPathMatch = (basePath: string, testPath: string): boolean => {
  const basePathSegments = (basePath ?? '/').slice(1).split('/');
  const testPathSegments = (testPath ?? '/').slice(1).split('/');
  return basePathSegments.every(
    (segment: string, idx: number) => segment === testPathSegments[idx],
  );
};

export const getStartingRouteByProviderTypeName = (
  providerTypeName: ProviderTypeNames | string,
): string => {
  const { providerDashboard } = useFlags<LDFlags>();
  let startingRoute = '';
  switch (providerTypeName) {
    case ProviderTypeNames.ADMISSIONS_SPECIALIST:
    case ProviderTypeNames.ADMISSIONS_OPERATIONS:
    case ProviderTypeNames.ADMISSIONS_SUPERVISOR:
    case ProviderTypeNames.PATIENT_SERVICE_REPRESENTATIVE:
      startingRoute = Path.MAUD_INQUIRIES;
      break;
    case ProviderTypeNames.PRACTICE_COORDINATOR:
    case ProviderTypeNames.MEDICAL_ASSISTANT:
      startingRoute = Path.MAUD_TASKS;
      break;
    default:
      startingRoute = providerDashboard ? Path.MAUD : Path.CALENDAR_SCHEDULE;
      break;
  }
  return startingRoute;
};
